import { Component, OnInit, inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { HeaderAppComponent } from '../../headers/header-app/header-app.component';
import { FormTemplateComponent } from '../../../shared/screen-templates/form-template/form-template.component';
import { PayeeFormFieldComponent } from '../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeInputDirective } from '../../../shared/payee-input/payee-input.directive';
import { MatError } from '@angular/material/form-field';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

type ForgotPasswordControls = {
  email: FormControl<string | null>;
};

@Component({
  selector: 'app-get-password-link',
  templateUrl: './get-password-link.component.html',
  styleUrls: ['./get-password-link.component.scss'],
  imports: [
    HeaderAppComponent,
    FormTemplateComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeInputDirective,
    MatError,
    PayeeButtonComponent,
    MatProgressSpinner,
  ],
})
export class GetPasswordLinkComponent implements OnInit {
  private fb = inject(FormBuilder);
  private titleService = inject(Title);
  private authService = inject(AuthService);
  private router = inject(Router);

  readonly forgotPasswordForm: FormGroup<ForgotPasswordControls>;

  readonly loading = signal(false);

  constructor() {
    this.forgotPasswordForm = this.fb.group<ForgotPasswordControls>({
      email: this.fb.control('', [Validators.required, Validators.email]),
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('Új jelszó kérése - Payee');
  }

  get email(): FormControl<string | null> {
    return this.forgotPasswordForm.controls.email;
  }

  readonly sendEmail = async (): Promise<void> => {
    if (this.forgotPasswordForm.invalid || this.loading()) {
      return;
    }

    try {
      this.loading.set(true);

      await this.authService.sendPasswordResetEmail({
        email: this.email.value!,
      });

      this.router.navigate(['/forgot-password-get-link-success'], {
        queryParams: {
          email: this.email.value,
        },
      });
    } finally {
      this.loading.set(false);
    }
  };
}
